import { Page } from '@backstage/core-components';
import {
  TechDocsReaderPageContent,
  TechDocsReaderPageSubheader,
} from '@backstage/plugin-techdocs';
import { TechDocsAddons } from '@backstage/plugin-techdocs-react';
import { TechDocsCodeSnippets as CodeSnippets } from '@appfolio/backstage-plugin-syntax-highlighter';
import {
  ContentFooter,
  ContentHeader,
  TechDocsLinks,
  Mermaid,
  NavigationTemplate,
  SecondarySidebar,
  RemoveFeedbackLink,
} from './addons';
import { TechDocsReaderPageHeader } from './TechDocsReaderPageHeader';
import { TechDocsReaderPageTabTitle } from './TechDocsReaderPageTabTitle';
import { configApiRef, useApi } from '@backstage/core-plugin-api';

const TechDocsReaderPageTabTitleWithAppTitle = () => {
  const config = useApi(configApiRef);
  return (
    <TechDocsReaderPageTabTitle
      baseTabTitleItems={[
        config.getOptional('app.title') ?? 'Developer Portal',
      ]}
    />
  );
};

const addons = (
  <TechDocsAddons>
    <CodeSnippets />
    <ContentFooter />
    <ContentHeader />
    <TechDocsLinks />
    <Mermaid
      lightConfig={{ theme: 'default' }}
      darkConfig={{ theme: 'dark' }}
    />
    <NavigationTemplate />
    <RemoveFeedbackLink />
    <SecondarySidebar />
  </TechDocsAddons>
);

export const techDocsReaderPage = (
  <Page themeId="documentation">
    <TechDocsReaderPageTabTitleWithAppTitle />
    <TechDocsReaderPageHeader />
    <TechDocsReaderPageSubheader />
    <TechDocsReaderPageContent />
    {addons}
  </Page>
);
